import { memo } from 'react';

export const HrBrick = memo(function HrBrick() {
  return (
    <>
      <hr />
      <style jsx>{`
        hr {
          margin: 18px 0;
          width: 78px;
          height: 20px;
          border: none;
          border-radius: 1px;
          background-color: var(--bgHotGreen);
        }
      `}</style>
    </>
  );
});
